import apiClient from "../api/apiClient"
import { Booker, PaginatedResponse } from "../../types"

export const bookerService = {
  async getBookers(params?: {
    page?: number
    limit?: number
    search?: string
  }): Promise<PaginatedResponse<Booker>> {
    const response = await apiClient.get<{
      info: {
        page: number
        limit: number
        total: number
        totalPages: number
        hasNextPage: boolean
      }
      results: Booker[]
    }>("/admin/users/get-all?type=booker", { params })
    console.log('Bookers response:', response.data)
    
    // Transform API response to match PaginatedResponse interface
    return {
      data: response.data.results,
      total: response.data.info.total,
      page: response.data.info.page,
      limit: response.data.info.limit,
      totalPages: response.data.info.totalPages,
    }
  },
}
